
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerJungleLogMid from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogMid";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunk1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 221, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6217, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 541, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 230, 139);
    this.add(pole_long_float_png);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 3021, -228);
    this.add(platformLog_3);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1441, 207);
    this.add(platformCabin);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1203, -348);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 4341, 143);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 4155, -366);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 3931, -358);
    this.add(gemMarker_3);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 3589, -123);
    this.add(crateMarker);

    // platformLog_6
    const platformLog_6 = new PlatformMarkerJungleLog(scene, 2058, -1);
    this.add(platformLog_6);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 1886, 142);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 2215, 142);
    this.add(pole_long_float_png_5);

    // platformLog_7
    const platformLog_7 = new PlatformMarkerJungleLog(scene, 2702, -3);
    this.add(platformLog_7);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 2530, 140);
    this.add(pole_long_float_png_6);

    // pole_long_float_png_7
    const pole_long_float_png_7 = new DecorationFloatingPoleLong(scene, 2859, 140);
    this.add(pole_long_float_png_7);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1396, 103);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1513, 99);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3406, -66);
    this.add(gemMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 3683, -348);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 2703, -88);
    this.add(gemMarker_11);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 825, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3840, -56);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 2068, -59);
    this.add(megaGemMarker_1);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 682, -2);
    this.add(platformMarkerLogLong);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerJungleLogMid(scene, 5688, 10);
    this.add(platformMarkerLogMid);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 1624, -241);
    this.add(platformMarkerLogLong_1);

    // platformMarkerLogLong_2
    const platformMarkerLogLong_2 = new PlatformMarkerJungleLogLong(scene, 3951, -270);
    this.add(platformMarkerLogLong_2);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, 832, 139);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 1118, 139);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 4043, 139);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 3757, 139);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 3466, 139);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 3155, 139);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 3607, 9);
    this.add(platformMarkerLogLong_3);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 4332, 240);
    this.add(platformMarkerSubmergedBarrel);

    // platformMarkerSubmergedBarrel_1
    const platformMarkerSubmergedBarrel_1 = new PlatformMarkerSubmergedBarrel(scene, 4679, 240);
    this.add(platformMarkerSubmergedBarrel_1);

    // platformCabin_1
    const platformCabin_1 = new PlatformMarkerCabin(scene, 5100, 211);
    this.add(platformCabin_1);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 5111, 98);
    this.add(megaGemMarker_3);

    // platformMarkerLogLong_4
    const platformMarkerLogLong_4 = new PlatformMarkerJungleLogLong(scene, 4738, -134);
    this.add(platformMarkerLogLong_4);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 419, -29);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1654, -277);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 3558, -299);
    this.add(checkpointMarker_2);

    // checkpointMarker_3
    const checkpointMarker_3 = new CheckpointMarker(scene, 4596, -168);
    this.add(checkpointMarker_3);

    // pole_long_float_png_2
    const pole_long_float_png_2 = new DecorationFloatingPoleLong(scene, 5905, 155);
    this.add(pole_long_float_png_2);

    // pole_long_float_png_3
    const pole_long_float_png_3 = new DecorationFloatingPoleLong(scene, 5463, 155);
    this.add(pole_long_float_png_3);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
